module.exports = __webpack_public_path__ + "static/media/IMG_1672.d22d581e.JPG";